<template>
  <img
    :alt="alt || 'Oats Overnight'"
    :width="image.width"
    :height="image.height"
    :src="pixel"
    :srcset="srcset"
    :loading="loading || 'lazy'"
  >
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useResponsiveImage } from '@/utils'
import type { Media, MediaImage } from '@/types/shopify'
export interface Props {
  image: Media | MediaImage
  alt?: string | null
  width: number
  loading?: string
}
const pixel = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjYGRgZAAAAAsAA8cA2jkAAAAASUVORK5CYII='
const props = defineProps<Props>()
const {
  downscale
} = useResponsiveImage(props.image)
const srcset = computed(() => {
  const width = Number(props.width || props.image.width)
  return [
    `${downscale(width)} 1x`,
    `${downscale(Math.round(width * 2))} 2x`,
    `${downscale(Math.round(width * 3))} 3x`
  ].join(', ')
})
</script>
